import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Button, Box, Typography, CircularProgress } from '@mui/material';

export const AuthStatus = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <CircularProgress size={24} />;
  }

  if (auth.error) {
    return (
      <Box>
        <Typography color="error">Authentication error: {auth.error.message}</Typography>
        <Button 
          className="button"
          variant="contained"
          color="primary"
          onClick={() => auth.signinRedirect()}
        >
          Log in
        </Button>
      </Box>
    );
  }

  if (auth.isAuthenticated) {
    return (
      <></>
      // <Box display="flex" alignItems="center">
      //   <Typography variant="body2" mr={2}>
      //     {auth.user?.profile.email || auth.user?.profile.name || 'Authenticated User'}
      //   </Typography>
      //   {/* <Button 
      //     variant="outlined" 
      //     size="small"
      //     onClick={() => auth.removeUser()}
      //   >
      //     Log out
      //   </Button> */}
      // </Box>
    );
  }

  return (
    <Button 
      variant="contained" 
      onClick={() => auth.signinRedirect()}
    >
      Log in
    </Button>
  );
};
